// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_ln-1";
export var quotedThread = "_ln-0";